module.exports = __webpack_public_path__ + "static/media/dislikeReaction.fa78ed96.svg";